import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
import Qs from "qs";

class DeviceAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'device';

	searchIp(ip) {
		let request = {
			url: `${this.getAPIUrl()}/search/ip?ip=${ip}`
		};

		return httpClient.getAsync(request);
	}
	searchAdvance(model) {
		let queryString = Qs.stringify(model || {});
		let request = {
			url: `${this.getAPIUrl()}/search/advance?${queryString}`
		};

		return httpClient.getAsync(request);
	}

	getReportData(payload) {
		let request = {
			url: `${this.getAPIUrl()}/report/data?${payload}`
		};

		return httpClient.getAsync(request);
	}

	createReportSchedule(payload) {
		let request = {
			url: `${this.getAPIUrl()}/report/schedule`,
			data: payload
		};
		return httpClient.postAsync(request);
	}

	getDomainMindMap(ip) {
		let request = {
			url: `${this.getAPIUrl()}/get_ip_mind_map?ip=${ip}`,
		};
		return httpClient.getAsync(request);
	}
	updateDataHot(payload) {
		let request = {
			url: this.getAPIUrl(),
			data: payload
		};
		return httpClient.putAsync(request, true);
	}
}

export default new DeviceAPI();
